import React from "react";
import {MedicineShortModel} from "@/app/api/medicines/models";
import styles from "./styles.module.scss";
import Image from "@/app/components/image";
import Space, {spaceSizes} from "@/app/components/Space";
import {BodyTitleText, FootnoteText, SubheadText} from "@/app/components/texts";
import {useTranslation} from "react-i18next";
import EmptyImage from "@/app/components/empty_image";
import StatusLine from "@/app/features/home/components/medicines/components/status_line";
import {prepareImage} from "@/app/utils/custom_function";

interface MedicineItemProps {
  item: MedicineShortModel;
  onClick?: (registration_number: string) => void;
}

const MedicineItem: React.FC<MedicineItemProps> = ({item, onClick}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(item.registration_number);
    }
  };

  return (
    <div className={styles.medicineItem} onClick={handleClick}>
      <div className={styles.imageWrapper}>
        {item.images == "" ? <EmptyImage/> : <Image asset={prepareImage(item.images)} className={styles.medicineImage}/>}
      </div>
      <Space h={spaceSizes.s28}/>
      <div className={styles.details}>
        <StatusLine commercialized={item.commercialized}/>
        <Space h={spaceSizes.s12}/>
        <BodyTitleText className={styles.name} text={item.name}/>
        <Space h={spaceSizes.s12}/>
        <SubheadText className={styles.activeIngredients} text={item.active_ingredients}/>
        <Space h={spaceSizes.s12}/>
        <FootnoteText className={styles.manufacturer} text={item.manufacturer}/>
      </div>
      <Space h={spaceSizes.s28}/>
    </div>
  );
};

export default MedicineItem;